export default __webpack_public_path__ + "static/merchmarket-7d49262df536b4a869baa6f725f7453b.jpg";